import React, { Component } from 'react';
import axios from '../../axios';
import moment from 'moment';
import { FOTO_PRESENSI_HOST } from "../../constants/siteConfig";
import {NavLink} from 'react-router-dom';
import Alert from 'react-s-alert';
import qs from 'qs';
import XLSX from 'xlsx'
import Paging from '../../components/Paging'
import ModalPresensi from "../../components/ModalPresensi";



class SiswaView extends Component {

    constructor(props) {
        super(props)
        this.state = {
            user_id : "",
            siswaNama:'',
            siswaKelas:'',
            tracking_lat:'',
            tracking_lng:'',
            alamat_lokasi:'',
            pageCount    : 0,
            currentPage  : 0,
            dataDetailSiswa : [],
            isLoading : false,
            isModalShow  : false,
        }
        this.exportFile = this.exportFile.bind(this);
        this.toggleModal     = this.toggleModal.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)


    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }
    loadDetailData() {

        const params = qs.stringify({
            user_id : this.props.match.params.user_id,
            status:'all',
            start:this.props.match.params.start,
            end:this.props.match.params.end,
            page: this.state.currentPage + 1,

        });
        axios({
            method: 'post',
            url: '/reportsiswadetail?' + params
        })
        .then((response) => {
            const result = response.data
            if (result.status === true) {

                this.setState({
                    dataDetailSiswa: result.data.presensis.data,
                    dataDetailExportSiswa: result.data.export,
                    tglFilter: this.props.match.params.start+' Sampai '+this.props.match.params.end,
                    siswaNama: result.data.siswa.user.user_nama,
                    siswaKelas: result.data.siswa.kelas.kelas_nama,
                    pageCount  : result.data.presensis.last_page,
                    isLoading: false
                })
            }
            else {

                Alert.error(result.text)
                this.setState({ isLoading: false })
            }
        })
        .catch((error) => {
            this.setState({ isLoading: false })
            Alert.error("Terjadi masalah internal !")
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadDetailData();
        });
    };

    exportFile() {
        let presensi = [["Nama Siswa", this.state.siswaNama ]]
        presensi.push(["Kelas", this.state.siswaKelas ])
        presensi.push(["Periode", this.state.tglFilter ])
        presensi.push([" "])
        presensi.push(["Nama Siswa", "Tanggal", "Kehadiran", "Type"])
        this.state.dataDetailExportSiswa.map(item => {
          presensi.push([
                    item.user_nama,
                    item.presensi_create_date+'-'+item.presensi_create_time,
                    item.presensi_status,
                    item.presensi_tipe,
                    ])
        })
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(presensi)
            XLSX.utils.book_append_sheet(wb, wsAll, "All Users")
            XLSX.writeFile(wb, "Rekap Presensi Siswa Per Jadwal-"+ moment().format('DD-MMMM-YYYY') +".xlsx")
      }

    componentDidMount() {
        this.loadDetailData()
    }

    render() {
        return (
            <div className="col-sm-12">


                <ModalPresensi
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    namaSiswa={this.state.siswaNama}
                    siswaKelas={this.state.siswaKelas}
                    tracking_lat={this.state.tracking_lat}
                    tracking_lng={this.state.tracking_lng}
                    alamat_lokasi={this.state.alamat_lokasi}
                    modalHeaderText="Detail Lokasi Absen Siswa"
                    modalBodyText="Detail Lokasi Absen Siswa"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-header">Detail Absensi Siswa Pelajaran Per Kelas
                                <button className="btn btn-primary pull-right" onClick={this.exportFile}> Export Data </button>
                    </div>

                    <div className="card-block">
                        <div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Siswa</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.siswaNama}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Kelas</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.siswaKelas}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Periode</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.tglFilter}</b></label>
                            </div>
                        </div>
                    </div>

                   {
                       this.state.dataDetailSiswa.length === 0 ? "Presensi tidak ditemukan" : (
                        <div className="card-block">
                            <table className="table table-striped animated fadeIn">
                                <thead>
                                    <tr>
                                        <td width="20">No</td>
                                        <td>Foto</td>
                                        <td>Nama</td>
                                        <td>Tanggal</td>
                                        <td>Kehadiran</td>
                                        <td>Status Izin</td>
                                        <td>Keterangan</td>
                                        <td>Type</td>
                                        <td>Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.dataDetailSiswa.map((item, i) => {
                                            return(
                                                <tr key={item.presensi_id}>
                                                    <td>{i + 1}</td>
                                                    <td>
                                                        <img
                                                            src={
                                                                item.presensi_foto !== ""
                                                                    ? FOTO_PRESENSI_HOST+item.presensi_foto
                                                                    : "./noimage.gif"
                                                            }
                                                            alt=""
                                                            className="img-thumbnail"
                                                            style={{ width: "100px" }}
                                                        />
                                                    </td>
                                                    <td>{item.user_nama}</td>
                                                    <td>{item.presensi_create_date}-{item.presensi_create_time}</td>
                                                    <td>
                                                        {item.presensi_status === 'not_taken' ? 'Alpha': item.presensi_status} <br/>
                                                        {
                                                            item.presensi_status === 'late' ? <span className="badge badge-danger">{ item.late } Menit</span> : ''
                                                        }
                                                    </td>
                                                    <td>{item.status_izin}</td>
                                                    <td>
                                                        {item.note}
                                                        <br/>
                                                        <br/>
                                                        {
                                                            item.attachment !== "" && item.attachment && item.attachment !== '-'
                                                                ? <a href={FOTO_PRESENSI_HOST+item.attachment} target="_blank" className="btn btn-sm btn-primary">
                                                                    <i className="fa fa-download"></i> Lampiran
                                                                  </a>
                                                                : ""
                                                        }
                                                    </td>
                                                    <td>{item.presensi_tipe}</td>
                                                    <td>
                                                        <NavLink
                                                            to={`${this.props.match.url}/edit/${item.presensi_id}/${item.siswa_id}`}
                                                            className="btn btn-danger btn-sm"
                                                        >Edit</NavLink>
                                                        {" "}
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            onClick={() => {
                                                                this.toggleModal();
                                                                this.setState({ tracking_lat: item.tracking_lat,
                                                                                    tracking_lng:item.tracking_lng,
                                                                                    alamat_lokasi:item.alamat_lokasi });
                                                            }}
                                                        >
                                                            Lokasi Absen
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            <Paging
                                handlePageClick={this.handlePageClick}
                                pageCount={this.state.pageCount}
                                currentPage={this.state.currentPage}
                            />
                        </div>
                       )
                   }
                </div>
            </div>
        );
    }
}

export default SiswaView;



// WEBPACK FOOTER //
// ./src/views/ReportPresensi/SiswaView.js